module.exports = __webpack_public_path__ + "h5/img/page_bg.937c173a.png";